module.exports = __webpack_public_path__ + "img/person_fengliang.63c6c49d.jpg";